<script>
import {useAdminCommonStore} from '~/store/admin-common/index.js'

export default {
  name: 'UserAddFill',
  props: {
    notification: {
      type: Object,
      default: () => ({
        count: 0,
        list: []
      })
    }
  },
  setup() {
    const adminCommonStore = useAdminCommonStore()
    return {adminCommonStore}
  },
  data() {
    return {
      dropdownVisible: false
    }
  },
  computed: {
    count() {
      return this.notification.count
    },
    list() {
      return this.notification.list
    }
  },
  methods: {
    onClickFooter(){
      this.dropdownVisible = false
      this.$router.push('/admin/member')
    },
    async onClickItem(item) {
      await this.adminCommonStore.putNotification({notificationId : item.id})
      this.dropdownVisible = false
      const id = item.targetId
      const type = item.type
      if ( type === 'MEMBER' || type === 'MODIFY' ) {
        this.$router.push(`/admin/member/${id}`)
      } else {
        this.$router.push(`/admin/management/apply/seminar/${id}?menu=4&subMenu=0`)
      }
      // emit으로 reload 호출
      this.$emit('reload')
    },
    async toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
    },
  }
}
</script>

<template>
  <div class="icon-wrap">
    <div class="icon" @click="toggleDropdown">
      <div class="is-12m badge">{{ count }}</div>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 14.252V22H4C3.99969 20.7789 4.27892 19.5739 4.8163 18.4774C5.35368 17.3809 6.13494 16.4219 7.10022 15.674C8.0655 14.9261 9.18918 14.4091 10.3852 14.1626C11.5811 13.9162 12.8177 13.9467 14 14.252V14.252ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM18 17V14H20V17H23V19H20V22H18V19H15V17H18Z"
          fill="#606060"
        />
      </svg>
    </div>
    <div v-if="dropdownVisible" class="dropdown-wrap">
      <div class="is-16m dropdown-header">신규 회원가입, 정보수정, 신청</div>
      <div class="dropdown-content">
        <div v-if="list.length > 0">
          <div v-for="(item, index) in list" :key="index" :class="['dropdown-item', {read : item.isRead}]" @click="onClickItem(item)">
            <div class="item-content">
              <div v-if="item.type === 'MEMBER'" class="item-content__title">
                <div class="is-14m title">회원가입</div>
                <div class="is-14m value">{{ item.title }}</div>
              </div>
              <div v-if="item.type === 'MODIFY'" class="item-content__title">
                <div class="is-14m title">정보수정</div>
                <div class="is-14m value">{{ item.title }}</div>
              </div>
              <div v-if="item.type === 'SEMINAR'" class="item-content__title">
                <div class="is-14m title">신청강좌</div>
                <div class="is-14m value">{{ item.subtitle }}</div>
              </div>
              <div class="item-content__content">
                <div class="is-14m time-wrap">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3062_17137)">
                      <path
                        d="M7.99992 15.1673C4.31792 15.1673 1.33325 12.1827 1.33325 8.50065C1.33325 4.81865 4.31792 1.83398 7.99992 1.83398C11.6819 1.83398 14.6666 4.81865 14.6666 8.50065C14.6666 12.1827 11.6819 15.1673 7.99992 15.1673ZM7.99992 13.834C9.41441 13.834 10.771 13.2721 11.7712 12.2719C12.7713 11.2717 13.3333 9.91514 13.3333 8.50065C13.3333 7.08616 12.7713 5.72961 11.7712 4.72941C10.771 3.72922 9.41441 3.16732 7.99992 3.16732C6.58543 3.16732 5.22888 3.72922 4.22868 4.72941C3.22849 5.72961 2.66659 7.08616 2.66659 8.50065C2.66659 9.91514 3.22849 11.2717 4.22868 12.2719C5.22888 13.2721 6.58543 13.834 7.99992 13.834ZM8.66658 8.50065H11.3333V9.83398H7.33325V5.16732H8.66658V8.50065Z"
                        fill="#909090"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_3062_17137">
                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>{{ item.createdAtText }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="is-14m dropdown-item">최근 7일 내역이 없습니다.</div>
        </div>
      </div>
      <div class="is-16m dropdown-footer" @click="onClickFooter">모든 회원 보기</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.icon-wrap {
  position: relative;

  .icon {
    cursor: pointer;

    .badge {
      position: absolute;
      top: -10px;
      right: -8px;
      border-radius: 32px;
      width: 24px;
      background: #0058aa;
      color: white;
      text-align: center;
      padding: 0 2px;
    }
  }

  .dropdown-wrap {
    position: absolute;
    top: 40px;
    right: -20px;
    width: 300px;
    background: white;
    border: 1px solid #e0e0e0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    .dropdown-header {
      color: white;
      padding: 8px 16px;
      background: #002063;
    }

    .dropdown-content {
      max-height: 400px;
      overflow-y: auto;
    }

    .dropdown-footer {
      cursor: pointer;
      border-top: 1px solid var(--cnsl-gray-200, #e6e6e6);
      background: var(--cnsl-white, #fff);
      color: #0058aa;
      padding: 8px 16px;
      text-align: center;
    }

    .dropdown-item {
      cursor: pointer;
      padding: 12px 16px;
      border-bottom: 1px solid #f2f2f2;

      &:last-child {
        border-bottom: none;
      }

      .item-content {
        .item-content__title {
          display: flex;
          gap: 8px;

          .title {
            min-width: 55px;
            color: #909090;
          }

          .value {
            .time-wrap {
              display: flex;
              gap: 4px;
              align-items: center;
              color: #909090;
            }
          }
        }

        .item-content__content {
          display: flex;
          gap: 8px;
          align-items: center;

          .title {
            color: #909090;
          }

          .value {
            color: #0058aa;
          }

          .time-wrap {
            margin-left: auto;
            display: flex;
            gap: 4px;
            align-items: center;
            color: #909090;
          }
        }
      }

      &.read {
        background-color: #E1E1E1;
      }
    }
  }
}
</style>
